import Button from "@shared/v2/Button";
import ArrowUpRightSolidV6 from "@icons/ArrowUpRightSolidV6";
import Header from "../../UI/Header";

const ConnectServices = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-[16px]">
      <Header header="Connect Services" />
      <div>
        <div className="tw-text-center tw-text-14px tw-leading-[20px] tw-font-normal tw-text-gray-75">
          Utilities and home service concierge.
        </div>
        <div className="tw-mt-[20px]">
          <Button
            schema="secondary"
            onClick={() =>
              window.open("https://partner.connectservices.com/prm/register-a-referral-tc", "_blank")
            }
            className="tw-mt-[4px] tw-w-full tw-h-[44px] !tw-rounded-[8px] tw-flex !tw-gap-[4px] tw-items-center tw-justify-center tw-text-14d !tw-normal-case"
          >
            <span className="tw-mr-[4px]">Refer to Connect Services</span>
            <ArrowUpRightSolidV6 />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConnectServices;
